import { render, staticRenderFns } from "./purchase.view.vue?vue&type=template&id=4b632908&scoped=true&lang=pug"
import script from "./purchase.view.vue?vue&type=script&lang=ts"
export * from "./purchase.view.vue?vue&type=script&lang=ts"
import style0 from "./purchase.view.vue?vue&type=style&index=0&id=4b632908&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b632908",
  null
  
)

export default component.exports